import { getPeriodForFilename } from './base-info/periods';

export const getFilenameWithPeriod = (baseName: string, periods?: string[], ext?: string): string => {
  const period = getPeriodForFilename(periods || []);
  const preparedExt = ext ? '.' + ext : '';
  return period ? `${baseName}_за_${period}${preparedExt}` : baseName;
};
